import React, { useEffect, useState } from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import MenuItem from '../MenuItem/index';
import HeaderModalForm from '../HeaderModalForm';
import headerData from '../headerData.json';
import MobileMenuButton from '../../MobileMenuButton';
import { Container, StyledButton, StyledUl, EmailCapture, EmailCaptureContainer } from './styles';

const WebsiteHeaderRightMenu = ({
  absolutePosition,
  contextualCta,
  customPhoneNumber,
  isMobileMenuOpened,
  landingPageMenuItems,
  landingPageWithoutItems,
  setMobileMenuOpened,
  showMenuItems,
  theme,
}) => {
  const [showHeaderForm, setHeaderForm] = useState(false);

  const handleScroll = e => {
    let bodyOffset = document.body.getBoundingClientRect();
    if (!absolutePosition) {
      setHeaderForm(true);
    } else {
      bodyOffset.top < -452 ? setHeaderForm(true) : setHeaderForm(false);
    }
  };

  useEffect(() => {
    if (!absolutePosition) {
      setHeaderForm(true);
    } else {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  });

  const mobileIconClicked = e => {
    setMobileMenuOpened(!isMobileMenuOpened);

    const driftChatBox = document.querySelector('.drift-frame-controller');

    if (driftChatBox) {
      driftChatBox.style.display = !isMobileMenuOpened ? 'none' : 'block';
    }
  };

  return (
    <Container>
      <StyledUl>
        {!landingPageWithoutItems &&
          headerData.additionalMenu.map((additionalMenuItem, index) => {
            const { type, title, hasSubMenu, link, name } = additionalMenuItem;
            const titleToRender =
              name === 'Phone Number' && customPhoneNumber ? customPhoneNumber : title;

            if (
              !landingPageMenuItems ||
              landingPageMenuItems === 'Both' ||
              landingPageMenuItems.includes(name)
            ) {
              return (
                <MenuItem
                  type={type}
                  title={titleToRender}
                  hasSubMenu={hasSubMenu}
                  link={link}
                  key={index}
                  display={
                    contextualCta?.__typename === 'ContentfulInlineMarketingForm' &&
                    showHeaderForm &&
                    theme === 'darkHeroHeader'
                  }
                />
              );
            }
          })}
        <div id="Original">
          {contextualCta?.__typename === 'ContentfulCallToAction' ? (
            contextualCta.useModalForm ? (
              <HeaderModalForm
                buttonLabel={contextualCta.buttonLabel}
                inlineMarketingForm={contextualCta.modalForm}
                type={contextualCta.color}
              />
            ) : (
              <StyledButton to={contextualCta.url} className="website-header--button-cta">
                {contextualCta.buttonLabel}
              </StyledButton>
            )
          ) : (
            contextualCta?.__typename === 'ContentfulInlineMarketingForm' && (
              <EmailCaptureContainer showHeaderForm={showHeaderForm}>
                <EmailCapture>
                  <SubscribeForm
                    inlineMarketingForm={contextualCta}
                    formType="Email Capture"
                    dataPosition="Header"
                    label={null}
                    shadow={false}
                    formClassNames="header-email-capture"
                  />
                </EmailCapture>
              </EmailCaptureContainer>
            )
          )}
        </div>
        {/* Test components for A/B Test */}
        <div id="Testing" style={{ display: 'none' }}>
          <HeaderModalForm
            buttonLabel="Get Started"
            inlineMarketingForm={{
              formTitle: 'Request your free demo',
              marketoForm: {
                buttonLabel: 'Agree and Get Started',
                knownVisitor: { type: 'form' },
                name: 'FORM Demo Request Part 1+2 (New Site 2020)',
                status: 'approved',
                url: 'https://app-sj26.marketo.com/#FO2175B2',
              },
            }}
          />
        </div>
        {showMenuItems && (
          <MobileMenuButton
            isMobileMenuOpened={isMobileMenuOpened}
            mobileIconClicked={mobileIconClicked}
          />
        )}
      </StyledUl>
    </Container>
  );
};

export default WebsiteHeaderRightMenu;
